/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Not_Specified23Inputs */

const en__field_enum_csjensblank_not_specified23 = /** @type {(inputs: _Field_Enum_Csjensblank_Not_Specified23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not specfied`)
};

const de__field_enum_csjensblank_not_specified23 = /** @type {(inputs: _Field_Enum_Csjensblank_Not_Specified23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ohne Angabe`)
};

/**
* | output |
* | --- |
* | "not specfied" |
*
* @param {_Field_Enum_Csjensblank_Not_Specified23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_not_specified23 = /** @type {((inputs?: _Field_Enum_Csjensblank_Not_Specified23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Not_Specified23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_not_specified23(inputs)
	return de__field_enum_csjensblank_not_specified23(inputs)
});
export { _field_enum_csjensblank_not_specified23 as "_field_enum_CSJENSBLANK_NOT_SPECIFIED" }